<template>
  <div>
    <h1>{{ $t('readonlyInformation') }}</h1>
    <div class="setting">
      <div class="userinfo-main">
        <!-- <div class="edit-section">
          <i class="iconfont iconbianji edit" v-if="!isEdit" @click="isEdit = !isEdit"></i>
          <template v-else>
            <i class="el-icon-check f-s-18" style="margin-right: 6px" @click="updateUser"></i>
            <i class="el-icon-close f-s-18" @click="cancelEdit"></i>
          </template>
        </div> -->
        <div class="desc-content">
          <!-- <div class="info-item">
            <div class="info-item-label">{{ $t('timeAndDateTheConfig') }}</div>
            <div class="info-item-content">
              <el-input v-if="isEdit" type="text" v-model="systemInfo.maintenanceCompany" />
              <template v-else>
                {{ systemInfo.maintenanceCompany }}
              </template>
            </div>
          </div>
          <div class="info-item">
            <div class="info-item-label">{{ $t('serialNumber') }}</div>
            <div class="info-item-content">
              <el-input v-if="isEdit" type="text" v-model="systemInfo.maintenanceCompany" />
              <template v-else>
                {{ systemInfo.maintenanceCompany }}
              </template>
            </div>
          </div>
          <br /> -->
          <div class="info-item">
            <div class="info-item-label">{{ $t('firmwareVersions') }}</div>
            <div class="info-item-content">
              <el-input v-if="isEdit" type="text" v-model="systemInfo.firmVersion" />
              <template v-else>
                <span v-html="firmVersionHtml"></span>
                <!-- <span v-html="">{{ systemInfo.firmVersion }}</span> -->
              </template>
            </div>
          </div>
          <div class="info-item">
            <div class="info-item-label">{{ $t('dateOfLastConfig') }}</div>
            <div class="info-item-content">
              <el-input v-if="isEdit" type="text" v-model="systemInfo.lastModifyInPanel" />
              <template v-else>
                {{ systemInfo.lastModifyInPanel }}
              </template>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 831px">
        <el-divider></el-divider>
      </div>
      <div class="history">
        <span class="title" ref="midBox" >{{ $t('eventLog') }}</span>
        <el-date-picker
          class="margin-left"
          v-model="date"
          :clearable="false"
          type="date"
          format="yyyy-MM-dd"
          :picker-options="options"
          :placeholder="$t('pleaseChoose')">
        </el-date-picker>
        <el-select class="margin-left" v-model="type" :placeholder="$t('pleaseChoose')">
          <el-option
            v-for="item in eventTypeArr"
            :key="item.value"
            :label="item.name"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button class="blue-btn margin-left" @click="getAlarmList" icon="el-icon-search" style="width: 40px"></el-button>
        <template v-if="eventLogArr.length > 0">
          <div class="result" style="margin:20px 0 10px;" :style="{height: height + 'px'}" v-if="height">
            <el-scrollbar style="height: 100%">
              <div class="list" v-for="item in eventLogArr" :key="item.id">
                <span>{{ moment(item.time).format('YYYY-MM-DD HH:mm:ss') }}</span>
                <span v-if="item.event">{{ item.event }}</span>
                <span>{{ item.descr }}</span>
              </div>
            </el-scrollbar>
          </div>
          <Pagination
            :total="total"
            :pageSize="pageSize"
            :currentPage="pageNumber"
            @change="getAlarmList"
            style="margin: 10px 5% 0;"
          />
        </template>
        <noData :height="height" :showBox="true" v-else />
      </div>
    </div>
  </div> 
</template>

<script>
import config from '../../common/config'
import { getAlarmList, getPanelDetail } from '../../api/panel'
import moment from 'moment'

export default {
  name: 'readonlyInformation',
  data () {
    return {
      systemInfo: {},
      isEdit: false,
      eventTypeArr: this.handleGlobalArr(config.eventTypeArr),
      date: new Date(),
      type: 0,
      eventLogArr: [],
      moment: moment,
      panelNo: this.$route.query.panelNo,
      projectId: this.$route.query.projectId,
      panelId: this.$route.query.panelId,
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      height: 0,
      options: {
        disabledDate: (date) => {
          return date > this.current
        }
      },
      current: new Date()
    }
  },
  watch: {
    $route (route) { // 在当前页面点选择其他项目时，及时更新新的panelNo和projectId，
      this.panelNo = route.query.panelNo
      this.projectId = route.query.projectId
    }
  },
  computed: {
    firmVersionHtml () {
      return this.systemInfo.firmVersion ? this.systemInfo.firmVersion.replace(/\n/g, '<br/>') : ''
    }
  },
  mounted () {
    this.getAlarmList()
    this.getPanelDetail()
    const height = window.innerHeight - this.$refs.midBox.getBoundingClientRect().top - 110
    this.height = height < 200 ? 200 : height
  },
  methods: {
    getAlarmList (pageObj = { pageNum: 1, pageSize: this.pageSize }) {
      const params = {
        panelNo: this.panelNo,
        projectId: this.projectId,
        time: moment(this.date).format('YYYY-MM-DD'),
        type: this.type,
        isPage: 1,
        pageNumber: pageObj.pageNum,
        pageSize: pageObj.pageSize
      }
      getAlarmList(params).then(res => {
        this.eventLogArr = res.data
        this.total = res.total
        this.pageSize = res.pageSize
        this.pageNumber = res.pageNumber
      })
    },
    getPanelDetail () {
      getPanelDetail({
        panelId: this.panelId,
        projectId: this.projectId
      }).then(res => {
        this.systemInfo = res.data
      })
    }
  }
}
</script>
<style lang="less" scoped>
.userinfo-main {
  .info-item {
    margin-top: 10px;
    min-height: 54px;
    padding: 10px 0;
    border-bottom: 1px solid #CCDEEE;
    // border-bottom: 1px solid @color-primary;
    display: inline-block;
    vertical-align: top;
    width: 390px;
    &:nth-of-type(2n) {
      margin-left: 50px;
    }
    .info-item-label {
      font-size: 16px;
    }
    .info-item-content {
      margin-top: 10px;
      min-height: 22px;
      display: flex;
      justify-content: space-between;
      .left {
        width: 50%;
      }
      .right {
        width: 50%;
      }
    }
  }
  .user-title {
    font-size: 16px;
    margin: 20px 0 10px;
  }
  .edit-section {
    text-align: right;
    height: 20px;
    overflow: hidden;
    i {
      cursor: pointer;
    }
  }
}
.history {
  width: 700px;
  .title {
    font-size: 18px;
  }
  .margin-left {
    margin-left: 15px;
  }
  .result .list {
    font-size: 14px;
    min-height: 36px;
    line-height: 36px;
    border-bottom: 1px solid #CCDEEE;
    span {
      margin-right: 15px;
    }
  }
}
h1 {
  font-size: 24px;
  font-weight: 400;
}
</style>
